import "./banner.css";
import { useEffect, useState } from "react";
import ContactFormModal from "../../header/HomeHeader/contact/ContactFormModal";

const Banner = () => {
  const [contactOpen, setContactOpen] = useState(false);

  useEffect(() => {
    const videoElement = document.querySelector("video");
    if (videoElement) {
      videoElement.play().catch((error) => {
        console.error("Autoplay failed:", error);
      });
    }
  }, []);
  return (
    <div className="
  relative
  w-full
  overflow-hidden
  min-h-[420px]
  sm:min-h-[500px]
  md:min-h-[600px]
  lg:min-h-[650px]
"
    >
      <video
        className="absolute top-0 left-0 w-full h-full object-cover"
        src="https://vizybilitystorage.blob.core.windows.net/videos/DMSDb_ALPHAOMEGA/WebApp/TuataraUSABanner.9348ec7ef8058df4b5cf.mp4?sp=r&st=2024-11-26T16:01:07Z&se=2028-12-31T00:01:07Z&spr=https&sv=2022-11-02&sr=b&sig=jY1JkjWRw0a4lXJ25ZeKmaASjx4WnVS%2Bmt2My%2FIj0eo%3D"
        loop
        muted
        playsInline
        preload="auto"
        onCanPlay={(e) => e.target.play()}
      ></video>
      <div className="absolute inset-0 flex items-center justify-center px-3 py-6 sm:px-6 sm:py-8 md:px-8 md:py-10">
        <div className="
  bg-[rgba(0,0,0,0.55)]
  px-4 py-5
  sm:px-8 sm:py-8
  md:px-10 md:py-10
  w-full
  max-w-[1000px]
  text-center
  rounded-xl
  text-white
">
          <div>
            <h1 className="font-[Rockwell] text-white font-bold 2xl:text-[30px] xl:text-[30px] lg:text-[28px] md:text-[24px] sm:text-[20px] text-[15px] leading-tight text-center">
              HEAVY-DUTY 4WD UTILITY VEHICLES BUILT FOR WORK
            </h1>
            <div className="flex items-center justify-center mb-3 mt-[5px] sm:mb-[20px]">
              <div className="bg-[#fff] sm:h-[8px] h-[4px] sm:w-[350px] w-[120px]"></div>
            </div>
            {/* <div
              className="font-[Roboto] text-white font-bold
        2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px]
         text-center"
            >
              Experience the difference with Tuatara—the utility vehicle built to evolve and excel. Explore our range of
              models and discover why Tuatara is the go-to choice for those who demand performance, reliability, and
              sustainability.
            </div> */}

      <p className="font-[Roboto] text-white font-bold
        lg:text-[18px] md:text-[16px] sm:text-[14px] text-[12px]
        leading-relaxed text-center mb-3 sm:mb-4">
        Tuatara UTVs deliver the power, durability, and reliability you need to get more done. Our heavy-duty 4WD utility vehicles are engineered for agriculture, construction, and commercial use – combining high payload capacity, all-terrain performance, and tough steel construction.
      </p>
      <p className="font-[Roboto] text-white font-bold
        lg:text-[18px] md:text-[16px] sm:text-[14px] text-[12px]
        leading-relaxed text-center mb-5 sm:mb-6">
        Explore the Tuatara range and discover why more operators across the USA are choosing a UTV built to work harder, last longer, and perform when it matters most.
      </p>
          </div>
          {/* H1 */}
          {/* <h1 className="kuunari-bold text-[22px] sm:text-[28px] md:text-[42px] leading-tight mb-3">
            Tuatara ATV – Most Capable Side-by-Side Utility Vehicle
          </h1> */}

          {/* Subheading */}
          {/* <h2 className="montserrat-semi-bold text-[18px] md:text-[22px] mb-4">
            Built for farms, adventure and off-road commercial work
          </h2> */}

          {/* Intro paragraph */}
          {/* <p className="montserrat-medium text-[13px] sm:text-[14px] md:text-[16px] leading-[22px] md:leading-[24px] mb-6">
            Tuatara ATVs are built to handle challenging conditions, offering the reliability and power of a true
            side-by-side utility vehicle. Tough, dependable, and ready for any job or adventure.
          </p> */}

          {/* CTA */}
          <button
            onClick={() => setContactOpen(true)}
            className="bg-[#6FBF4A] text-white px-5 py-2 sm:px-5 sm:py-3 text-[12px] sm:text-sm md:text-base font-semibold uppercase hover:opacity-90 transition"
          >
            Contact Us
          </button>

          <ContactFormModal
            open={contactOpen}
            handleClose={() => setContactOpen(false)}
          />

        </div>
      </div>

      {/* <img src={CardUpImg} className=" relative top-0 left-0 w-full h-full object-cover" /> */}
      {/* <div className=" md:bg-transparent bg-[#000] md:py-0 py-[50px]">
        <div className="relative z-1 flex flex-col items-end justify-center h-auto md:h-[calc(100svh-100px)] text-end text-white custom-container">
          <div className="md:max-w-[560px] w-auto p-[30px] bg-[rgba(56,56,56,0.64)] ">
            <div className="banner-nz-text kuunari-bold">PURCHASE THE MOST VERSATILE SIDE-BY-SIDE</div>
            <div className="banner-nz-sub-text mt-[10px]  montserrat-medium text-[16px] leading-[24px]">
              Our ATV side-by-side vehicles (Electric and Petrol) are purpose-built for off-road running and designed
              specially to be every farmer's primary workhorse, but the real strength of the Tuatara UTV is its versatility, making it ideal for a wide range of activities, including farming, horticulture, agricultural contracting, hunting, golf courses, retirement villages, mining, zoos, district council ground works, airports, power stations, civil construction, fighting forest fires… and the list goes on.  We know this because we have supplied Tuataras to every one of the occupations listed.
              <br/>
              Reliability and low maintenance are the name of the game,s and you need not look any further than the Tuatara to meet those requirements And while the TUATARA is often categorised as an ATV, it is more correctly an off-road utility vehicle (UTV) because frankly the Tuatara will go where the others can't, and it will carry more and tow more than its rivals, if it has any.
            </div>
            <p className="flex  mt-[17px]">
              <span className="banner-nz-sub-text flex items-center justify-center mr-[5px] montserrat-semi-bold text-[16px] leading-[24px]">
                <img src={StarIcon} alt="" className="w-[16px]" />
                Powerful!
              </span>
              <span className="banner-nz-sub-text flex items-center justify-center mr-[5px] montserrat-semi-bold text-[16px] leading-[24px]">
                <img src={StarIcon} alt="" className="w-[16px]" />
                Go Anywhere
              </span>
              <span className="banner-nz-sub-text flex items-center justify-center mr-[5px] montserrat-semi-bold text-[16px] leading-[24px]">
                <img src={StarIcon} alt="" className="w-[16px]" />
                Versatile
              </span>
              <span className="banner-nz-sub-text flex items-center justify-center montserrat-semi-bold text-[16px] leading-[24px]">
                <img src={StarIcon} alt="" className="w-[16px]" />
                Low Maintenance
              </span>
            </p>
          </div>
        </div>
      </div> */}
    </div>
  );
};
export default Banner;
